import useUserStore from '@shared/stores/useUserStore.js'
import { isFromApp } from '@shared/helpers/isFromApp'

// In-app users can be sent back into the app via deeplink, except resubscribers
// (users with a subscription) who continue in the web flow.
export const canReturnToApp = (): boolean =>
  isFromApp() && !useUserStore().user?.currentSubscription
